<template>
  <div class="clinic-history tab-personal-background">
    <h4 class="mb-2 text-blue fw-light">Consulta y Evolución</h4>
    <a class="btn-add" @click="openModal()"><i class="las la-plus text-green"></i> <span class="p-2 pt-0 pb-0">Agregar Consulta</span></a>
    <hr />
    <h6 class="mb-2 text-blue fw-light">Consultas registradas</h6>
    <!-- Cards responsivas -->
    <div class="row" v-show="!loadStart">
      <div class="col-md-12 mb-3">
        <div class="card shadow-sm mb-3" v-show="items.length == 0 && !hasItems">
          <div class="card-body">  
            <p class="card-text">No existen consultas cargadas.</p>
          </div>
        </div>
        <div class="card shadow-sm mb-3" v-show="items.length > 0" v-for="item in items" :key="item.id">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="card-title m-0">{{ item.date }}</h6>
              </div>
              <div class="d-flex justify-content-end m-3 mt-1 mb-1" >
                  <a class="fs-5 text-secondary" title="Ver o Editar Consulta o Evolución" @click="editItem(item.id, item.description, item.cieCodes)">
                      <i class="pointer ps-1 las la-pen p-2 text-blue"></i>
                  </a> 
                  <a class="fs-5 text-secondary" @click="deleteData(item.id)" title="Eliminar Consulta o Evolución">
                      <i class="pointer border-start ps-1 las la-trash p-2 text-blue"></i>  
                  </a>
              </div>  
            </div>
            <div class="mb-3" v-if="item.cieCodes.length > 0"> 
              <p v-for="itemCode in item.cieCodes" :key="itemCode.cie10Code" class="card-text text-muted">
                <small><span class="text-blue">Código: </span><b class="text-blue">{{ itemCode.cie10Code }}</b> - {{ itemCode.cie10Description }}</small>
              </p>
            </div>    
            <small v-if="item.description != ''"><b>Descripción:</b></small>
            <p v-if="item.description != ''" class="card-text">{{ item.description }}</p>
            <p class="card-text text-muted">
              <small class="text-blue fw-light fst-italic">Profesional: {{ item.profName }}</small>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal nueva nota -->
  <div class="modal fade" id="modalNuevaNota" tabindex="-1" aria-labelledby="modalNuevaNotaLabel" aria-hidden="true" data-bs-backdrop="false" data-bs-keyboard="false" style="z-index:1000000">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="ref == ''" class="modal-title" id="modalNuevaNotaLabel">Nueva Consulta</h5>
          <h5 v-if="ref != ''" class="modal-title" id="modalNuevaNotaLabel">Editar Consulta</h5>
          <button type="button" class="btn-close" @click="closeModal()" aria-label="Cerrar"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label" for="cie10Code">Diagnósticos CIE-10 (Opcional):</label>
            <!-- Contenedor del buscador con posición relativa -->

            <div class="row"> 
              <div class="col-md-6">
                <div class="mb-3 search-container">
                  <div class="">
                    <input type="text" id="busqueda" class="form-control" placeholder="Buscar enfermedad o condición o código..." autocomplete="off" v-model="searchCie" @keyup="buscarCategoria()">
                  </div>
                  <!-- Contenedor de resultados flotantes justo debajo del input -->
                  <div id="resultados-busqueda" class="mb-3"></div>
                </div>
              </div>
            </div>
            
            <div v-if="diagnoses.length > 0" class="mb-3"> 
              <strong>Descripción CIE-10:</strong>
              <div  v-for="(d, index) in diagnoses" :key="index">    
                <div class="text-primary">
                  <a class="fs-5 text-danger" @click="removeDiagnosis(index)" title="Eliminar">
                      <i class="pointer ps-1 las la-trash p-2"></i>  
                  </a>
                  <span class="text-blue"><b>{{ d.cie10Code }}</b></span> {{ d.cie10Description }}
                  <hr class="m-0">
                </div>
              </div>
            </div>    
          </div>
          <div class="mb-3">
            <label class="form-label" for="description">Detalle de la consulta / evolución:</label>
            <textarea class="form-control" attr-id="description" v-model="description" rows="3" required placeholder="Describa el antecedente"></textarea>
          </div>
          
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary w-50 p-3 pb-2 pt-2" @click="saveData()" :disabled="disabledBtn"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span> Guardar</button>
        </div>
      </div>
    </div>
  </div>

  <div class="mx-auto position-fixed bottom-0 end-0 start-0 end-0 p-0 pt-3 pb-3" style="z-index: 11800000000; width: fit-content; margin-bottom: 0px;">
      <div id="toastcontainerClinic" class="w-25">
      </div>
  </div>
</template>

<script>
import axios from "axios";
import { Toast } from 'bootstrap';
import { Modal } from "bootstrap";
export default {
  name: "tabSessions",
  props: ['userId', 'consId'],
  data() {
    return {
      errorText: '',
      toastColor: '',
      toastBg: '',
      toastNumber: 0,
      modal: '',
      localZone: '',
      disabled: false,
      disabledBtn: false,
      loading: false,
      disabled: false,
      disabledBtn: false,
      loading: false,
      profName: '',
      description: '',
      diagnoses: [],
      ref: '',
      searchCie: '',
      items: [],
      next: 0,
      hasItems: false,
      loadStart: true,
    };
  },
  mounted: function () {
    this.localZone =  moment.tz.guess();
    var data = JSON.parse(localStorage.getItem('userData'));
    this.profName = data.userFirstName + ' ' + data.userLastName;
    this.findData();
  },
  unmounted: function () {
      try{
          this.modal.hide();
      }catch(e){

      }
  },
  methods: {
    addDiagnosis(code, desc) {
      const item = {
        cie10Code: code,
        cie10Description: desc
      };
      this.diagnoses.push(item); 
    },
    removeDiagnosis(index) {
      this.diagnoses.splice(index, 1);
    },
    editItem(id, description, cie10Code){
      this.ref = id;
      this.description = description;
      this.diagnoses = cie10Code;
      this.openModal();
    },
    openModal(){
        var modal = new Modal(document.querySelector('#modalNuevaNota'))
        this.modal = modal;
        modal.show()
    },
    closeModal(){
        this.modal.hide();
        var elems = document.querySelectorAll(".bad");
        [].forEach.call(elems, function(el) {
            el.classList.remove("bad");
        });
        this.diagnoses = [];
        this.ref = '';
        this.description = '';
        this.cie10Code = '';
        this.cie10Description = '';
        this.disabled = false;
        this.disabledBtn = false;
        this.loading = false;
    },
    resaltarCoincidencias(texto, termino) {
      const regex = new RegExp(`(${termino})`, 'gi');
      return texto.replace(regex, '<span style="color:#027be3;">$1</span>');
    },
    async buscarCategoria() {
      const resultadosDiv = document.getElementById('resultados-busqueda');
      resultadosDiv.innerHTML = '';
      var payload = {
          action: 'find-code-cie',
          browserCountry: this.$route.params.browserCountry,
          userLang: this.$route.params.userLang,
          urlcode: window.location.host,
          search: this.searchCie.trim(),    
      } 
      await axios.post('/index.php', payload).then(result => {  
        const json = result.data;
        if (json.encontrado && Array.isArray(json.results) && json.results.length) {
          const listGroup = document.createElement('div');
          listGroup.classList.add('list-group');
          for (const it of json.results) {
            const btn = document.createElement('button');
            btn.className = 'list-group-item list-group-item-action';

            // Resaltar coincidencia
            let btnText = `${it.title}` + (it.code ? ` [${it.code}]` : '');
            btnText = this.resaltarCoincidencias(btnText, this.searchCie.trim());
            btn.innerHTML = btnText;

            btn.dataset.id = it.id;
            btn.dataset.code = it.code;         // guardamos el código aquí
            btn.addEventListener('click', () => {
              // Actualizar selección
              if(btn.dataset.code != ''){
                this.addDiagnosis(btn.dataset.code, it.title);
              }
              resultadosDiv.innerHTML = '';
              this.searchCie = '';
            });

            listGroup.appendChild(btn);
          }
          resultadosDiv.appendChild(listGroup);
          // Mostrar el contenedor flotante
          resultadosDiv.style.display = 'block';
        }else{
          resultadosDiv.textContent = "No se encontró ninguna coincidencia.";
          resultadosDiv.style.display = 'block';
        }
      })
    },
    async saveData(){
      var elems = document.querySelectorAll(".bad");
      [].forEach.call(elems, function(el) {
          el.classList.remove("bad");
      });
      var payload = {
          action: 'save-medical-sessions',
          browserCountry: this.$route.params.browserCountry,
          userLang: this.$route.params.userLang,
          urlcode: window.location.host,
          timezone: this.localZone,
          dataReceiver: this.userId,
          consId: this.consId,
          profName: this.profName,
          ref: this.ref,  
          description: this.description,
          cie10Code: this.diagnoses
      } 
      this.disabledBtn = true;
      this.loading = true;
      await axios.post('/index.php', payload).then(result => { 
        this.disabledBtn = false;
        this.loading = false;
        if(result.data.status == '200'){
          if(this.ref == ''){
            this.errorText = 'Consulta agregada';
          }else{
            this.errorText = 'Consulta actualizada';
          }
          this.toastBg = 'bg-info';
          this.toastColor = 'text-dark';
          this.toastNumber++;
          var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
          try{
              document.querySelector('#toastcontainerClinic').insertAdjacentHTML("afterend", t);
              var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
              var bsAlert = new Toast(myAlert);//inizialize it
              bsAlert.show();//show it
          }catch(e){

          }		
          this.items = [];
          this.next = 0;
          this.findData();
          this.closeModal();
        }else{
          if(result.data.status == '400'){
            if(result.data.error == 'E4'){
              this.errorText = 'Debes ingresar el detalle de la consulta o evolución.';
              try{
                document.querySelector("[attr-id='description']").classList.add("bad"); 
                document.querySelector("[attr-id='description']").select();
              }catch(e){

              }
            }else if(result.data.error == 'E5'){
              this.errorText = 'El detalle de la consulta o evolución no debe tener un máximo de 5000 caracteres.';
              try{
                document.querySelector("[attr-id='description']").classList.add("bad"); 
                document.querySelector("[attr-id='description']").select();
              }catch(e){

              }
            }else if(result.data.error == 'E6'){
              this.errorText = 'Un código CIE-10 ingresado no es válido o no se encuentra registrado.'; 
            }
            this.toastBg = 'bg-danger';
            this.toastColor = 'text-dark';
            this.toastNumber++;
            var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
            try{
                document.querySelector('#toastcontainerClinic').insertAdjacentHTML("afterend", t);
                var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                var bsAlert = new Toast(myAlert);//inizialize it
                bsAlert.show();//show it
            }catch(e){

            }		
          }
        }
      })
      .catch(error => {
          this.disabledBtn = false;
          this.loading = false;
      })   
    },
    async deleteData(val){
      if (confirm("Estás por borrar una consulta. ¿Deseás continuar?")) {
        var payload = {
            action: 'delete-medical-sessions',
            browserCountry: this.$route.params.browserCountry,
            userLang: this.$route.params.userLang,
            urlcode: window.location.host,
            ref: val,    
        } 
        this.disabledBtn = true;
        this.loading = true;
        await axios.post('/index.php', payload).then(result => { 
          this.disabledBtn = false;
          this.loading = false;
          if(result.data.status == '200'){    
            this.errorText = 'Consulta eliminada'; 
            this.toastBg = 'bg-info';
            this.toastColor = 'text-dark';
            this.toastNumber++;
            var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
            try{
                document.querySelector('#toastcontainerClinic').insertAdjacentHTML("afterend", t);
                var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                var bsAlert = new Toast(myAlert);//inizialize it
                bsAlert.show();//show it
            }catch(e){

            }		
            this.items = [];
            this.next = 0;
            this.findData();
            this.closeModal(); 
          }
        })
        .catch(error => {
            this.disabledBtn = false;
            this.loading = false;
        })   
      }
    },
    async findData(){
      var payload = {
          action: 'find-medical-sessions',
          browserCountry: this.$route.params.browserCountry,
          userLang: this.$route.params.userLang,
          urlcode: window.location.host,
          timezone: this.localZone,
          dataReceiver: this.userId,
          consId: this.consId,
          next: this.next,
      } 
      await axios.post('/index.php', payload).then(result => { 
        this.loadStart = false;
        let sum = 0;
        Object.keys(result.data).forEach(key => {
            this.hasItems = true;
            this.items.push(result.data[sum]); 
            sum++;                        
        });
        this.next = this.next+100;           
        
      })
      .catch(error => {
          
      })   
    },
  },
};
</script>

<style scoped>
.clinic-history .btn-add{
  display: flex;
  align-items: center;
  color: #212529;
  text-decoration: none;
  cursor: pointer;
}
.clinic-history .btn-add .la-plus {
    width: 30px;
    height: 30px;
    font-size: 24px;
    padding: 0;
    border-radius: 50%; 
    background: #00c7a2 ;
    color: #fff;
    text-decoration: none;
    padding: 3px;
}
.modal-dialog-centered {
    display: flex;
    align-items: center;
    min-height: calc(100% - 83px);
}
.modal-dialog-scrollable {
    height: calc(100% - 89px);
}
/* Estilo para el contenedor flotante de resultados */
.search-container {
  position: relative;
}
@media screen and (max-width: 720px) {
  .search-container {
    position: relative;
    width: 100%;
  }
}
#resultados-busqueda {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 153px;
    overflow-y: auto;
    background-color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 999;
    display: none;
    right: 0;
    border-radius: 0 0 9px 9px;
    overflow: hidden;
    overflow-y: auto;
}

/* Estilo para los resultados de búsqueda */
.list-group-item {
  cursor: pointer;
  transition: background-color 0.3s;
}

.list-group-item:hover {
  background-color: #f1f1f1;
}
</style>